const addToCart = () => {
  const purchaseOptions = document.querySelectorAll('.purchase-option');
  const addToCartButton = document.querySelector('.add-to-cart-button');

  purchaseOptions.forEach(option => {
    option.addEventListener('click', function () {
      purchaseOptions.forEach(opt => opt.classList.remove('purchase-option--selected'));
      this.classList.add('purchase-option--selected');

      const sellingPlanId = this.getAttribute('data-selling-plan-id');
      addToCartButton.setAttribute('data-selling-plan-id', sellingPlanId);
    });
  });

  addToCartButton.addEventListener('click', async function () {
    const buttonText = this.querySelector('.button-text');
    const loadingSpinner = this.querySelector('.loading-overlay__spinner');
    const variantId = this.getAttribute('data-variant-id');
    const sellingPlanId = this.getAttribute('data-selling-plan-id');

    if (buttonText) {
      buttonText.style.display = 'none';
    }
    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
    }

    if (sellingPlanId && sellingPlanId !== 'null') {
      await addToCartWithDrawer({
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId
      });
      setTimeout(() => {
        getCartTotal();
      }, 2000);
    } else {
      await addToCartWithDrawer({
        id: variantId,
        quantity: 1
      });
      setTimeout(() => {
        getCartTotal();
      }, 2000);
    }
  });



  async function addToCartWithDrawer(config) {
    var id = config.id;
    var quantity = config.quantity || 1;
    var selling_plan = typeof config.selling_plan !== 'undefined' ? config.selling_plan : null;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity,
        selling_plan: selling_plan
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function (sections) {
        const inlineCart = document.querySelector('.inline-cart');
        const inlineCartPageOverlay = document.querySelector('.inline-cart__page-overlay');

        inlineCart.classList.add('active');
        inlineCartPageOverlay.classList.add('active');

        if (sections['cart-icon-bubble'] && cartIconBubble) {
          var iconHTML = parser
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('#cart-icon-bubble');

          if (iconHTML) {
            cartIconBubble.innerHTML = iconHTML.innerHTML;
          }
        }

        setTimeout(function () {
          const buttonText = document.querySelector('.add-to-cart-button .button-text');
          const loadingSpinner = document.querySelector('.add-to-cart-button .loading-overlay__spinner');
          buttonText.style.display = 'block';
          loadingSpinner.classList.add('hidden');
        }, 10);
      })
      .catch(function (err) {
        console.error('Cart update failed:', err);
      });
  }

  async function getCartTotal() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed to fetch cart data');
      const cart = await res.json();


      const freeShippingThreshold = window.cartData.freeShippingThreshold;
      const totalPriceInCents = cart.total_price;
      const totalPriceFormatted = (totalPriceInCents / 100).toFixed(2);

      if (totalPriceFormatted >= freeShippingThreshold) {
        document.querySelector('.shipping-info__header').style.display = 'none';
        document.querySelector('.shipping-info__header--free').style.display = 'block';
      } else {
        document.querySelector('.shipping-info__header').style.display = 'block';
        document.querySelector('.shipping-info__header--free').style.display = 'none';
      }

      return totalPriceFormatted;
    } catch (err) {
      console.error('Error fetching cart total:', err);
      return null;
    }
  }


}

export default addToCart;